import { useNativePlatform } from "@/hooks/useNativePlatform";
import { cn } from "@/lib/utils";
import { useNativeSheetOpensExpanded } from "@/lib/native/useNativeSheetOpensExpanded";

/** Expandable native bottom sheet props (legal, dealer portal, etc.). */
export function useNativeExpandableSheetProps(
  open: boolean,
  options?: { className?: string; nativeClass?: string },
) {
  const { isNative } = useNativePlatform();
  useNativeSheetOpensExpanded(open, isNative);

  return {
    sheetOpen: open,
    expandable: isNative,
    className: cn(
      isNative &&
        (options?.nativeClass ??
          "native-sheet-expandable max-w-none w-full"),
      options?.className,
    ),
  };
}
